import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/Login' //登录
import Index from '@/components/Index' //主页
import User from '@/components/user/User' //用户中心
import Veri from '@/components/veri/veri' //预约核销
import RoomStatus from '@/components/roomStatus/RoomStatus' //房态维护
import RoomPrice from '@/components/roomPrice/RoomPrice' //房价维护

//订单处理
import Order from '@/components/order/Order' //订单列表 
import OrderEdit from '@/components/order/OrderEdit' //订单处理
import OrderPrint from '@/components/order/OrderPrint' //订单预览打印
//查看付款水单
import Payments from '@/components/payment/payments' //付款水单
//查看房价房态
import RoomPriceAndStatus from '@/components/RoomPriceAndStatus/RoomPriceAndStatus' //查看房价房态

//首页介绍页面
const HotelJoin = resolve => require(['@/components/html/hotelJoin'], resolve) //合作加盟
const About = resolve => require(['@/components/html/about'], resolve) //关于我们
const ContactUs = resolve => require(['@/components/html/contactUs'], resolve) //联系我们
const Recruit = resolve => require(['@/components/html/recruit'], resolve) //诚聘英才


Vue.use(Router)

export default new Router({
    routes: [{
            path: '/login',
            name: 'login',
            component: Login,
            meta: { isLogin: true }
        },
        {
            path: '/',
            name: 'loginIdx',
            component: Login,
            meta: { isLogin: true }
        },
        {
            path: '/index',
            name: 'Index',
            component: Index,
            // meta:{keepAlive:true}
        },
        {
            path: '/hotelJoin',
            name: 'HotelJoin',
            component: HotelJoin,
            meta: { keepAlive: true, isLogin: true }
        },
        {
            path: '/about',
            name: 'about',
            component: About,
            meta: { keepAlive: true, isLogin: true }
        },
        {
            path: '/contactUs',
            name: 'contactUs',
            component: ContactUs,
            meta: { keepAlive: true, isLogin: true }
        },
        {
            path: '/recruit',
            name: 'recruit',
            component: Recruit,
            meta: { keepAlive: true, isLogin: true }
        },
        {
            path: '/user',
            name: 'user',
            component: User,
        },

        {
            path: '/veri',
            name: 'veri',
            component: Veri,

        },

        {
            path: '/order',
            name: 'Order',
            component: Order,
            meta: { keepAlive: true }
        },
        {
            path: '/roomStatus',
            name: 'roomStatus',
            component: RoomStatus,
        },
        {
            path: '/roomPrice',
            name: 'roomPrice',
            component: RoomPrice,
        },
        {
            path: '/orderEdit',
            name: 'orderEdit',
            component: OrderEdit
        },
        {
            path: '/orderPrint',
            name: 'orderPrint',
            component: OrderPrint
        },
        {
            path: '/payments',
            name: 'payments',
            component: Payments
        },
        {
            path: '/roomPriceAndStatus',
            name: 'roomPriceAndStatus',
            component: RoomPriceAndStatus
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js